import { render, staticRenderFns } from "./SmallBtnToggle.vue?vue&type=template&id=1526db5c&"
import script from "./SmallBtnToggle.vue?vue&type=script&lang=js&"
export * from "./SmallBtnToggle.vue?vue&type=script&lang=js&"
import style0 from "./SmallBtnToggle.vue?vue&type=style&index=0&id=1526db5c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports